(function () {
  var root = document.querySelector('.m-wcup-phasetwo');
  if (!root) return;

  // Smooth scroll for anchor links
  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (!href || href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // Shared expiry state
  var isExpired = false;
  var countdownEnd = null;

  function getPacificOffsetMinutes(year, month, day) {
    function nthSunday(monthIndex, nth) {
      var date = new Date(Date.UTC(year, monthIndex, 1, 12, 0, 0));
      while (date.getUTCDay() !== 0) {
        date.setUTCDate(date.getUTCDate() + 1);
      }
      date.setUTCDate(date.getUTCDate() + 7 * (nth - 1));
      return date;
    }

    var dstStart = nthSunday(2, 2);
    var dstEnd = nthSunday(10, 1);
    var candidate = new Date(Date.UTC(year, month, day, 12, 0, 0));

    if (candidate >= dstStart && candidate < dstEnd) {
      return -420;
    }

    return -480;
  }

  function parseCountdownTarget(raw) {
    if (!raw) return null;

    var trimmed = String(raw).trim();
    var match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?\s*(PDT|PST|UTC|GMT|[+-]\d{2}:\d{2})?$/i);

    if (!match) {
      var parsed = new Date(trimmed);
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    var year = parseInt(match[1], 10);
    var month = parseInt(match[2], 10) - 1;
    var day = parseInt(match[3], 10);
    var hour = parseInt(match[4], 10);
    var minute = parseInt(match[5], 10);
    var second = parseInt(match[6] || '0', 10);
    var tz = (match[7] || '').toUpperCase();

    var offsetMinutes = null;
    if (tz === 'PDT') {
      offsetMinutes = -420;
    } else if (tz === 'PST') {
      offsetMinutes = -480;
    } else if (tz === 'UTC' || tz === 'GMT') {
      offsetMinutes = 0;
    } else if (/^[+-]\d{2}:\d{2}$/.test(tz)) {
      var offsetParts = tz.match(/^([+-])(\d{2}):(\d{2})$/);
      if (offsetParts) {
        var sign = offsetParts[1] === '-' ? -1 : 1;
        offsetMinutes = sign * (parseInt(offsetParts[2], 10) * 60 + parseInt(offsetParts[3], 10));
      }
    }

    if (offsetMinutes === null) {
      offsetMinutes = getPacificOffsetMinutes(year, month, day);
    }

    return new Date(Date.UTC(year, month, day, hour, minute, second) - offsetMinutes * 60000);
  }

  // Countdown
  root.querySelectorAll('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown');
    countdownEnd = parseCountdownTarget(raw);
    if (!countdownEnd) {
      countdownEnd = new Date(raw.replace(' ', 'T'));
    }
    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minsEl = el.querySelector('[data-cd-minutes]');
    var secsEl = el.querySelector('[data-cd-seconds]');
    var labelEl = el.querySelector('[data-cd-label]');
    var expiredLabel = el.getAttribute('data-expired-label') || 'Event closed';

    function pad(n) { return n < 10 ? '0' + n : n; }

    function update() {
      var diff = countdownEnd - new Date();
      if (diff <= 0) {
        isExpired = true;
        if (labelEl) labelEl.textContent = expiredLabel;
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        // Lock distribution if it's already initialized
        if (typeof lockDistribution === 'function') lockDistribution();
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minsEl) minsEl.textContent = pad(m);
      if (secsEl) secsEl.textContent = pad(s);
    }

    update();
    setInterval(update, 1000);
  });

  // Ticket distribution
  var dist = root.querySelector('[data-wcup-distribution]');
  if (dist) {
    var totalTickets = parseInt(dist.getAttribute('data-total-tickets'), 10) || 0;
    var remCountEl = root.querySelector('[data-remaining-count]');
    var remTotalEl = root.querySelector('[data-remaining-total]');
    var remFillEl = root.querySelector('[data-remaining-fill]');
    var submitBtn = root.querySelector('[data-submit-picks]');
    var steppers = dist.querySelectorAll('[data-team-stepper]');
    var form = root.querySelector('[data-wcup-submit-form]');

    function getAssigned() {
      var sum = 0;
      steppers.forEach(function (s) {
        sum += parseInt(s.querySelector('[data-team-count]').textContent, 10) || 0;
      });
      return sum;
    }

    function updateEntrySummary(code, count) {
      var item = root.querySelector('[data-entry-code="' + code + '"]');
      if (item) {
        var countEl = item.querySelector('[data-entry-count]');
        if (countEl) countEl.textContent = count;
        item.style.display = count > 0 ? 'flex' : 'none';
      }
      var totalEl = root.querySelector('[data-entry-total]');
      if (totalEl) totalEl.textContent = getAssigned();
    }

    function lockDistribution() {
      isExpired = true;
      steppers.forEach(function (s) {
        var plusBtn = s.querySelector('[data-step="1"]');
        var minusBtn = s.querySelector('[data-step="-1"]');
        if (plusBtn) plusBtn.disabled = true;
        if (minusBtn) minusBtn.disabled = true;
      });
      if (submitBtn) submitBtn.disabled = true;
    }

    function updateState() {
      if (isExpired) {
        lockDistribution();
        return;
      }
      var assigned = getAssigned();
      var remaining = totalTickets - assigned;
      if (remCountEl) remCountEl.textContent = remaining;
      if (remTotalEl) remTotalEl.textContent = totalTickets;
      if (remFillEl) remFillEl.style.width = totalTickets > 0 ? ((assigned / totalTickets) * 100) + '%' : '0%';
      if (submitBtn) submitBtn.disabled = (assigned === 0 || remaining !== 0);

      steppers.forEach(function (s) {
        var countEl = s.querySelector('[data-team-count]');
        var plusBtn = s.querySelector('[data-step="1"]');
        var minusBtn = s.querySelector('[data-step="-1"]');
        var card = s.closest('[data-team-card]');
        var count = parseInt(countEl.textContent, 10) || 0;
        if (plusBtn) plusBtn.disabled = remaining <= 0;
        if (minusBtn) minusBtn.disabled = count <= 0;
        if (card) card.classList.toggle('is-filled', count > 0);
      });
    }

    steppers.forEach(function (stepper) {
      var countEl = stepper.querySelector('[data-team-count]');
      var plusBtn = stepper.querySelector('[data-step="1"]');
      var minusBtn = stepper.querySelector('[data-step="-1"]');
      var code = stepper.getAttribute('data-team-code');

      function change(delta) {
        var count = parseInt(countEl.textContent, 10) || 0;
        var assigned = getAssigned();
        var remaining = totalTickets - assigned;
        if (delta > 0 && remaining <= 0) return;
        var newCount = Math.max(0, count + delta);
        if (newCount === count) return;
        countEl.textContent = newCount;
        updateEntrySummary(code, newCount);
        updateState();
      }

      if (plusBtn) plusBtn.addEventListener('click', function () { change(1); });
      if (minusBtn) minusBtn.addEventListener('click', function () { change(-1); });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        if (isExpired) return;

        var assigned = getAssigned();
        var remaining = totalTickets - assigned;
        if (assigned === 0 || remaining !== 0) return;

        var picks = {};
        steppers.forEach(function (s) {
          var code = s.getAttribute('data-team-code');
          var count = parseInt(s.querySelector('[data-team-count]').textContent, 10) || 0;
          if (count > 0) picks[code] = count;
        });

        var customerId = form.querySelector('[name="customer_id"]').value;
        var totalTix = parseInt(form.querySelector('[name="total_tickets"]').value, 10);

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting\u2026';
        }

        fetch('https://banilausa.com/apps/webhooks/czgcyn2t', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': '6e4v2m1f1f0q0e415i0u6m337s3g32351d7v022r60541t15041r762269753r2k'
          },
          body: JSON.stringify({
            customer_id: String(customerId),
            champion_picks: Object.entries(picks).map(function (entry) { return entry[0] + ':' + entry[1]; }).join(','),
            total_tickets: totalTix,
            timestamp: new Date().toISOString()
          })
        })
        .then(function (res) {
          if (res.ok) {
            showClientConfirmation(picks, totalTix);
          } else {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Submit';
            }
            alert('Something went wrong. Please try again.');
          }
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit';
          }
          alert('Network error. Please try again.');
        });
      });
    }

    function showClientConfirmation(picks, totalUsed) {
      var distBlock = root.querySelector('.m-ph2-dist');
      var sectionInner = root.querySelector('#team-distribute .m-ph2-section-inner');

      var ticketLabel =
        (distBlock && distBlock.getAttribute('data-ticket-label')) || 'Tickets';

      var listHtml = '';

      Object.entries(picks).forEach(function (entry) {
        var code = entry[0];
        var count = entry[1];
        var teamName = code;

        root.querySelectorAll('[data-team-stepper]').forEach(function (s) {
          if (s.getAttribute('data-team-code') === code) {
            var card = s.closest('[data-team-card]');
            if (card) {
              var n = card.querySelector('.m-ph2-team-name');
              if (n) teamName = n.textContent.trim();
            }
          }
        });

        listHtml +=
          '<div class="m-ph2-dist-confirm__item">' +
            '<span>' + teamName + '</span>' +
            '<span>' + count + ' ' + ticketLabel + '</span>' +
          '</div>';
      });

      var confirmTitle =
        (distBlock && distBlock.getAttribute('data-confirm-title')) ||
        'Picks Submitted!';

      var confirmSub =
        (distBlock && distBlock.getAttribute('data-confirm-sub')) ||
        'Your champion picks have been saved.';

      var confirmFooter =
        (distBlock && distBlock.getAttribute('data-confirm-footer')) ||
        'Total: [[total]] tickets used';

      confirmFooter = confirmFooter.replace('[[total]]', totalUsed);

      var confirmHtml =
        '<div class="m-ph2-dist-confirm">' +
          '<div class="m-ph2-dist-confirm__icon" aria-hidden="true">\u2713</div>' +
          '<div class="m-ph2-dist-confirm__title">' + confirmTitle + '</div>' +
          '<div class="m-ph2-dist-confirm__sub">' + confirmSub + '</div>' +
          '<div class="m-ph2-dist-confirm__list">' + listHtml + '</div>' +
          '<div class="m-ph2-dist-confirm__note">' + confirmFooter + '</div>' +
        '</div>';

      var formEl = root.querySelector('[data-wcup-submit-form]');
      if (formEl) formEl.style.display = 'none';

      if (sectionInner && !sectionInner.querySelector('.m-ph2-dist-confirm')) {
        sectionInner.insertAdjacentHTML('beforeend', confirmHtml);
      }

      if (remCountEl) remCountEl.textContent = '0';
      if (remFillEl) remFillEl.style.width = '100%';
    }

    updateState();
  }
})();
